// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media only screen and (min-width:1904px){.container{max-width:1185px}}.w-page-login,.w-page-password_reset_confirmation,.w-page-register{max-width:700px}.b-common-label{align-items:center;background:hsla(0,0%,4%,.435);border:2px solid #fff!important;border-radius:4px!important;display:flex!important;font-size:.85rem;justify-content:center;line-height:1!important;text-align:center;text-transform:uppercase}.b-common-label .v-avatar{margin-right:8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
